import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';
import { useLanguage } from '../../contexts/LanguageContext';

function ProtectedRoute() {
  const location = useLocation();
  const { t } = useLanguage();
  const { initializing, isAuthenticated } = useAuth();

  if (initializing) {
    return (
      <main className="auth-loading-screen">
        <Loader2 size={34} />
        <h1>{t('auth.loading')}</h1>
      </main>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return <Outlet />;
}

export default ProtectedRoute;